export default "__VITE_ASSET__Brfho2Qt__"